import React from "react";

const Card = ({ onNavigation, card, quietStatus, sequence, currentIndex }) => {
  const handleNextClick = (e) => {
    e.preventDefault();
    onNavigation(1);
  };

  const renderedBeacon = () => {
    const identifier = `${currentIndex.flow}-${currentIndex.section + 1}`;
    if (card.beacon.isVisible) {
      return (
        <div>
          <div className={`beacon-container ${card.beacon.position}`}>
            <button
              onClick={handleNextClick}
              data-identifier={identifier}
              className="beacon"
              aria-label="Navigate to Next Page"></button>
          </div>
          <div className={`caret ${card.beacon.position}`}></div>
        </div>
      );
    } else if (!card.snack.isVisible) {
      return (
        <div>
          <div className={`caret ${card.beacon.position}`}></div>
        </div>
      );
    }
  };

  const renderedText = () => {
    if (card.text) {
      return <p>{card.text}</p>;
    }
  };

  const renderCardClasses = () => {
    let cardClasses = "app-card";
    if (quietStatus && card.text) {
      cardClasses = cardClasses + "";
    } else {
      cardClasses = cardClasses + " hidden";
    }
    if (card.snack.isVisible) {
      cardClasses = cardClasses + ` snack-${card.snack.position}`;
    }
    if (sequence) {
      cardClasses = cardClasses + " delay";
    } else {
      cardClasses = cardClasses + " no-delay";
    }
    return cardClasses;
  };

  return (
    <div
      className={renderCardClasses()}
      style={{
        top: card.position.y,
        left: card.position.x,
      }}>
      <div className="content">
        {renderedText()}
        {renderedBeacon()}
      </div>
    </div>
  );
};

export default Card;
